import React, { useEffect, useState } from 'react';
import '../styles/init.css'; // Asegúrate de incluir el archivo CSS para los estilos
import { useAuth } from '../context/AuthContext';

import { API_BASE } from '../config';
function Init() {
    const { logout, token, userRole } = useAuth(); // Obtener el token del contexto

    const [pendingRequests, setPendingRequests] = useState(0);

    useEffect(() => {
      if (!token) return undefined;
      const fetchCount = async () => {
        try {
          const response = await fetch(`${API_BASE}/quantity-requests/pending-count/`, {
            headers: { Authorization: `Token ${token}` },
          });
          if (response.ok) {
            const data = await response.json();
            setPendingRequests(data.count);
          }
        } catch (err) {
          // A failed badge poll must never break the control panel.
        }
      };
      fetchCount();
      const interval = setInterval(fetchCount, 20000);
      return () => clearInterval(interval);
    }, [token]);

    const handleLogout = () => {
        logout();
    };

    const handleDatabaseExport = async () => {
      try {
          const response = await fetch(`${API_BASE}/export_all_data`, {
              method: 'GET',
              headers: {
                  'Authorization': `Token ${token}`,
              }
          });

          if (!response.ok) {
              console.error('Error al exportar:', response.status, await response.text());
              alert('Error al exportar los datos.');
              return;
          }

          // 📌 Imprimir los headers de la respuesta para verificar el Content-Type
          console.log("Headers:", response.headers.get("Content-Type"));

          // Verificar si el servidor devuelve un ZIP
          const contentType = response.headers.get("Content-Type");
          const isZip = contentType && contentType.includes("application/zip");

          if (!isZip) {
              alert("El servidor no devolvió un archivo ZIP. Verifica la configuración del servidor.");
              return;
          }

          // Convertir la respuesta en un blob y descargarla como ZIP
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "data_export.zip"; // 📌 Asegurarnos de descargarlo como ZIP
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          alert("Exportación de datos completada.");
      } catch (error) {
          console.error("Error:", error);
          alert("Error de conexión al exportar los datos.");
      }
  };


    if (userRole === 'scanner') {
      return (
        <div className="init-page">
          <button className="logout-button" onClick={handleLogout}>
              Cerrar Sesión
          </button>
          <div className="init-container">
            <h1 className="init-title">Panel de Control</h1>
            <button className="init-btn" onClick={() => window.location.href = '/admin/test-scanner'}>
              Test Scanner
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="init-page">
        <button className="logout-button" onClick={handleLogout}>
            Cerrar Sesión
        </button>
        <div className="init-container">
          <h1 className="init-title">Panel de Control</h1>

          <button className="init-btn" onClick={() => window.location.href = '/admin'}>
            Ordenes
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/carga'}>
            Carga
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/screen'}>
            Pantalla
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/search-po'}>
            Detalles OC
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/solicitudes'}>
            Solicitudes{pendingRequests > 0 ? ` (${pendingRequests})` : ''}
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/barcode'}>
            Código de barra
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/load_sku'}>
            Cargar nuevos SKU
          </button>

          {/* <button className="init-btn" onClick={() => window.location.href = '/admin/info_sku'}>
            Targa - Pallet
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/info_sku2'}>
            Targa - Rack
          </button> */}

          <button className="init-btn" onClick={() => window.location.href = '/admin/recepcion-stock'}>
            Ingreso Stock
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/contenedor'}>
            Contenedor
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/storage'}>
            Reponedor
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/production'}>
            Producción
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/vaciar-picking'}>
            Vaciar Picking
          </button>

          <button className="init-btn" onClick={handleDatabaseExport}>
            Base de Datos
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/test-scanner'}>
            Test Scanner
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/admin/usuarios'}>
            Usuarios
          </button>

          <button className="init-btn" onClick={() => window.location.href = '/editar-stock'}>
            Edición de Stock
          </button>
        </div>
      </div>
    );
}

export default Init;
